module.exports = __webpack_public_path__ + "img/gb9120_6_c.prt.47380201.jpg";